import { defineComponent as _defineComponent } from 'vue'
import useRoomInviteControl from './useRoomInviteHooks';
import SvgIcon from '../common/base/SvgIcon.vue';
import TuiButton from '../common/base/Button.vue';
import Contacts from '../ScheduleConference/Contacts.vue';
import SuccessIcon from '../common/icons/SuccessIcon.vue';
import copyIcon from '../common/icons/CopyIcon.vue';
import Dialog from '../common/base/Dialog';

export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  setup(__props) {

const {
  t,
  invitationFeatureDetails,
  showContacts,
  contactsConfirm,
  contacts,
  remoteEnteredUserList,
  isShowRoomShareForm,
  userId,
  userName,
  inviteInfoList,
  onCopy,
  copyRoomIdAndRoomLink,
} = useRoomInviteControl();

return { __sfc: true,t, invitationFeatureDetails, showContacts, contactsConfirm, contacts, remoteEnteredUserList, isShowRoomShareForm, userId, userName, inviteInfoList, onCopy, copyRoomIdAndRoomLink, SvgIcon, TuiButton, Contacts, SuccessIcon, copyIcon, Dialog }
}

})